// extracted by mini-css-extract-plugin
export var center = "styles-module__center___z1ocw";
export var trailContainer = "styles-module__trailContainer___LcIYa";
export var trailLoading = "styles-module__trailLoading___oBXTC";